export const getMandateRequest =
	(bankId, scopeId) =>
	(generatedId, fromAccountId, endpoint, mandateRecordType, mandateStartIndex, mandateMaxRecords) => {
		const uri = endpoint.resolve(
			bankId,
			scopeId,
			fromAccountId,
			mandateRecordType,
			mandateStartIndex,
			mandateMaxRecords
		);
		const { method, x_bpi_version } = endpoint;
		return {
			id: generatedId,
			method,
			uri,
			x_bpi_version,
		};
	};
